function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { get, AuthenticationTypes } from '@shared/services/http/httpProtocol';
const commonHttpOptions = {
    requireCorrelationId: true,
    stringifyPostData: false,
    authenticationType: AuthenticationTypes.Spza,
    setBearerHeader: true
};
export const LinkedInQueryStrings = {
    LegacyOfferId: 'offer_id',
    ApiVersion: 'api-version'
};
/**
 * Get Linkedin product group information.
 * @param legacyOfferId legacy offer identifier.
 * @param linkedInAPI Linkedin API route.
 * @param legacyOfferId Linkedin API version.
 * @returns Promise with the response, containing Linkedin product group information or null if information doesn't exist.
 */ export function getLinkedInProductgroupInfo(_) {
    return _getLinkedInProductgroupInfo.apply(this, arguments);
}
function _getLinkedInProductgroupInfo() {
    _getLinkedInProductgroupInfo = _async_to_generator(function*({ legacyOfferId, linkedinAPI, linkedinAPIVersion }) {
        const linkedInProductGroup = yield get(`${linkedinAPI}/product_groups`, commonHttpOptions).addQueryEntry(LinkedInQueryStrings.ApiVersion, linkedinAPIVersion).addQueryEntry(LinkedInQueryStrings.LegacyOfferId, legacyOfferId).request();
        return {
            linkedInProductGroup
        };
    });
    return _getLinkedInProductgroupInfo.apply(this, arguments);
}
